import { InsuranceCompany, InsurancePayerOption } from '../../__generated__/api'

/**
 * Gets the incident type based on the selected insurance and payer
 *
 * @param insurances The list of available insurances
 * @param selectedInsurance The selected insurance ID
 * @param selectedInsurancePayer The selected insurance payer ID
 * @returns The incident type or undefined
 */
export const getIncidentType = (
  insurances: InsuranceCompany[],
  selectedInsurance: number | null,
  selectedInsurancePayer: string | null
): string | undefined => {
  if (selectedInsurance === null) return undefined

  // Get the selected insurance company
  const insuranceCompany = insurances.find((ins) => ins.id === selectedInsurance)

  if (!insuranceCompany || selectedInsurancePayer === null) return undefined

  const payerOption = insuranceCompany.insurancePayerOptions.find(
    (option) => option.id === selectedInsurancePayer
  )

  return payerOption?.incidentType ?? undefined
}

/**
 * Find an insurance option across all companies
 */
export const findPayerOption = (
  insurances: InsuranceCompany[],
  payerId: string
): { option: InsurancePayerOption; companyId: number } | null => {
  for (const company of insurances) {
    const option = company.insurancePayerOptions.find((opt) => opt.id === payerId)
    if (option) {
      return { option, companyId: company.id }
    }
  }
  return null
}

/**
 * Find a fallback option for the given fallback ID
 */
export const findFallbackOption = (
  insurances: InsuranceCompany[],
  fallbackId: string
): { option: InsurancePayerOption; companyId: number } | null => {
  return findPayerOption(insurances, fallbackId)
}
